import api from './api';

export const adminService = {
  getDashboard: () => api.get('/admin/dashboard'),
  getMetrics: () => api.get('/admin/metrics'),
  getRevenue: () => api.get('/admin/revenue'),

  getTenants: (params) => api.get('/admin/tenants', { params }),
  getTenantById: (tenantId) => api.get(`/admin/tenants/${tenantId}`),
  suspendTenant: (tenantId, data) => api.post(`/admin/tenants/${tenantId}/suspend`, data),
  updateTenantPlan: (tenantId, plan) => api.patch(`/admin/tenants/${tenantId}/plan`, { plan }),

  getUsers: (params) => api.get('/admin/users', { params }),
  getUserById: (tenantId, userId) => api.get(`/admin/tenants/${tenantId}/users/${userId}`),
  impersonateUser: (tenantId, userId) =>
    api.post(`/admin/tenants/${tenantId}/users/${userId}/impersonate`),
  updateUserStatus: (tenantId, userId, status) =>
    api.patch(`/admin/tenants/${tenantId}/users/${userId}/status`, { status }),
  resetUserPassword: (tenantId, userId) =>
    api.post(`/admin/tenants/${tenantId}/users/${userId}/reset-password`),

  sendBroadcast: (data) => api.post('/admin/broadcast', data),
};
